module.exports = __webpack_public_path__ + "img/icon7.63c96eda.jpg";